import type { IconProps } from '../../types/global.types';

const ArrowLeftIcon = ({ size }: IconProps) => {
  return (
    <svg
      width={size || '18'}
      height={size || '18'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 9.5C14.7761 9.5 15 9.27614 15 9C15 8.72386 14.7761 8.5 14.5 8.5L4.80298 8.5L8.83448 4.87165C9.03974 4.68692 9.05638 4.37078 8.87165 4.16552C8.68692 3.96027 8.37077 3.94363 8.16552 4.12836L3.16552 8.62835C3.06016 8.72317 3 8.85826 3 9C3 9.14174 3.06016 9.27683 3.16552 9.37165L8.16552 13.8716C8.37077 14.0564 8.68692 14.0397 8.87165 13.8345C9.05638 13.6292 9.03974 13.3131 8.83448 13.1283L4.80298 9.5L14.5 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
